import { getDefaultField } from '@shared/lib/fields/getDefaultField'

export const enum RegFormFields {
  personName = 'restorator_name',
  email = 'restorator_email',
  phone_contact = 'restorator_phone',
}

export const enum PlaceFormFields {
  name_establishment = 'restaurant_name',
  city = 'city',
  address = 'address',
  social_link = 'social_link',
  type_organisation = 'organization_type',
  inn = 'inn',
  kpp = 'kpp',
  name_organisation = 'organization_name',
}

export const enum OrgTypes {
  OOO = 'ООО',
  IP = 'ИП',
}

const INN_CHECKSUM_MESSAGE = 'ИНН введён неверно'

export const INN_VALIDATIONS = {
  [OrgTypes.IP]: {
    'inn-12': 'Максимальное количество символов - 12',
    'inn-checksum': INN_CHECKSUM_MESSAGE,
  },
  [OrgTypes.OOO]: {
    'inn-10': 'Максимальное количество символов - 10',
    'inn-checksum': INN_CHECKSUM_MESSAGE,
  },
}

const maskInn = (value: string, length: 10 | 12): string => {
  const digits = String(value || '')
    .replace(/\D/g, '')
    .slice(0, length)

  if (length === 10) {
    const p1 = digits.slice(0, 4)
    const p2 = digits.slice(4, 9)
    const p3 = digits.slice(9, 10)
    return [p1, p2, p3].filter(Boolean).join('-')
  }

  const p1 = digits.slice(0, 4)
  const p2 = digits.slice(4, 10)
  const p3 = digits.slice(10, 12)
  return [p1, p2, p3].filter(Boolean).join('-')
}

export const INN_MASKS = {
  [OrgTypes.OOO]: (value: string) => maskInn(value, 10),
  [OrgTypes.IP]: (value: string) => maskInn(value, 12),
}

const FIELDS = {
  // рега
  [RegFormFields.personName]: getDefaultField('input', {
    name: RegFormFields.personName,
    value: '',
    required: true,
    settings: {
      showRequired: true,
      label: 'Имя и фамилия',
      placeholder: '',
    },
  }),
  [RegFormFields.phone_contact]: getDefaultField('input_tel', {
    name: RegFormFields.phone_contact,
    value: '',
    required: true,
    settings: {
      showRequired: true,
      label: 'Телефон для связи',
      placeholder: '+7 (000) 000-00-00',
    },
  }),
  [RegFormFields.email]: getDefaultField('input_email', {
    name: RegFormFields.email,
    value: '',
    required: true,
    settings: {
      showRequired: true,
      label: 'E-mail для связи',
      placeholder: 'example@rambler.ru',
    },
  }),

  // заведение
  [PlaceFormFields.name_establishment]: getDefaultField('input', {
    name: PlaceFormFields.name_establishment,
    value: '',
    required: true,
    settings: {
      showRequired: true,
      label: 'Название заведения',
      placeholder: '',
    },
  }),
  [PlaceFormFields.city]: getDefaultField('select', {
    name: PlaceFormFields.city,
    value: null,
    required: true,
    settings: {
      showRequired: true,
      label: 'Город',
      placeholder: 'Выберите город',
      options: [{ id: null, value: 'loading', label: 'Загрузка...', disabled: true }],
    },
  }),
  [PlaceFormFields.address]: getDefaultField('input', {
    name: PlaceFormFields.address,
    value: '',
    settings: {
      label: 'Адрес',
      placeholder: 'Укажите адрес',
    },
  }),
  [PlaceFormFields.social_link]: getDefaultField('input', {
    name: PlaceFormFields.social_link,
    value: '',
    required: true,
    validations: {
      url: 'Неверный формат ссылки',
    },
    settings: {
      label: 'Ссылка на сайт или соцсети',
      showRequired: true,
      placeholder: 'https://',
    },
  }),
  [PlaceFormFields.type_organisation]: getDefaultField('radio', {
    name: PlaceFormFields.type_organisation,
    value: OrgTypes.OOO,
    required: true,
    settings: {
      label: 'Тип организации',
      showRequired: true,
      hint: '',
      options: [
        { id: OrgTypes.OOO, name: OrgTypes.OOO, label: OrgTypes.OOO, disabled: false },
        { id: OrgTypes.IP, name: OrgTypes.IP, label: OrgTypes.IP, disabled: false },
      ],
    },
  }),
  [PlaceFormFields.name_organisation]: getDefaultField('input', {
    name: PlaceFormFields.name_organisation,
    value: '',
    required: true,
    settings: {
      showRequired: true,
      label: 'Название организации',
      placeholder: '',
      hint: 'Для ООО вводите название в кавычках',
    },
  }),
  [PlaceFormFields.inn]: getDefaultField('input', {
    name: PlaceFormFields.inn,
    value: '',
    required: true,
    validations: {
      ...INN_VALIDATIONS[OrgTypes.OOO],
    },
    settings: {
      showRequired: true,
      label: 'ИНН',
      placeholder: '',
      mask: INN_MASKS[OrgTypes.OOO],
    },
  }),
  [PlaceFormFields.kpp]: getDefaultField('input', {
    name: PlaceFormFields.kpp,
    value: '',
    required: true,
    settings: {
      showRequired: true,
      label: 'КПП',
      placeholder: '',
    },
  }),
}

export const getField = <K extends keyof typeof FIELDS>(nameField: K, defaultValue?: string | object) => {
  return (defaultValue ? { ...FIELDS[nameField], value: defaultValue } : FIELDS[nameField]) as (typeof FIELDS)[K]
}
